var _style, _path, _path2, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _rect, _rect2, _rect3, _rect4, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E01B1E;}\n\t.st1{clipPath:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.8,514.6c-7.1,112.1-91.1,207.3-204.8,232.1c51.4-42.4,95.8-99.2,118.9-175.1v0 c8.9-29.3,18.4-54,20.1-89.3c0.2-3-0.9-0.7-4.2,1.8c-0.3,0.3-0.8,0.7-1.3,1.2c-7,6.1-12.8,13.3-17.3,21.4 c-10.3,18.4-25.1,41.3-45.2,65.1c-68.5,80.9-199.4,172-428,129.6c0-0.4,0-0.8,0.1-1.2l27-173.3l32.3-207.2L194,218.6 c3.2-20.7,21.7-36,43.4-36h20.3l-6,68.5c-1.5,17.8,12.2,33.5,30.7,35c1,0.1,1.9,0.1,2.8,0.1c17.3,0,32-13,33.5-29.6l6.5-73.9h191.8 l6.1,73.8c1.4,16.7,16.1,29.8,33.4,29.8c0.9,0,1.9,0,2.8-0.1c8.9-0.7,17-4.7,22.8-11.2c5.8-6.6,8.6-14.9,7.9-23.6l-5.7-68.6h10 c21.5,0,39.9,15,43.3,35.5l19.3,115.1l11.7,69.3l9.3,55.4c1,5.6,1.7,11.2,2.2,16.9C681.4,488.2,681.6,501.6,680.8,514.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.2,252.5l-8-97.6c-4.7-56.8-52.9-100.2-112-100.9l-61.3-0.7c-0.5,0-1,0-1.4,0 C331.6,53.3,282,97.1,277,153.7l-8.6,98.7c-0.8,8.9,6.1,16.7,15.3,17.5c0.5,0,1,0.1,1.4,0.1c8.6,0,16-6.4,16.7-14.8l8.6-98.7 c3.5-39.8,38.1-70.8,79.8-70.8c0.4,0,0.8,0,1.2,0l61.3,0.7c41.7,0.5,75.6,31.1,78.9,71.1l8,97.6c0.7,8.4,8,14.9,16.6,14.9 c0.5,0,1,0,1.4-0.1C567,269.2,573.9,261.4,573.2,252.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M415.6,383.4c13.3,0,20.9,0,34.6,2.4c11.3,1.9,19.3,4.5,24.2,7.8c4.9,3.3,7.3,7.9,7.3,13.7 c0,3.7-0.9,6.5-2.7,8.6c-1.8,2.1-5.6,4.6-11.5,7.6c-6.9,3.6-10.8,7.7-11.8,12.5c-1,4.8-0.4,14.4-0.7,47.3 c-0.3,31.4,1.3,45.4,1,51.6c-0.3,6.3,0,12.4-1.2,18.3c-3.4,17.3-9.4,30.9-19.8,40.7c-8.5,8.1-19.5,14.4-32.9,19 c-13.4,4.6-27.5,6.9-42.3,6.9c-13.1,0-26.3-1.7-39.5-5.2c-13.2-3.4-24.7-8.2-34.4-14.2c-8.1-5-14.5-11.7-19.2-20.2 c-4.7-8.5-7.1-17.5-7.1-27.1c0-11.8,3.7-21.6,11.2-29.4c7.5-7.8,16.8-11.6,28.1-11.6c11,0,20.4,3.3,28.1,9.8 c7.7,6.6,11.5,14.8,11.5,24.5c0,2.5-0.7,6.6-2.1,12.4c-0.2,1.2-0.4,2.5-0.4,3.9c0,3.8,1.4,6.9,4.1,9.2 c2.7,2.4,6.3,3.6,10.8,3.6c7.9,0,14.3-3.6,19.2-10.7c4.9-7.1,9.8-16.5,9.8-28.1l0.3-16.2l0.1-38.7c-1.1-26.4-1.4-33.4-1.9-38.1 c-0.5-4.7-1.9-8.5-4-11.5c-1.8-2.4-3.3-3.9-4.7-4.6c-1.4-0.7-5.1-1.8-11.1-3.4c-2.8-0.6-5.3-2.2-7.3-5c-2-2.7-3-5.6-3-8.7 c0-6.4,2.5-11.5,7.5-15.4c5-3.8,13.2-7,24.6-9.3C393.2,383.5,402.1,383.4,415.6,383.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,545.8 289.5,619.9 259.6,619.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,535.8 293.6,619.9 289.5,619.9 259.6,545.8  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,525.8 297.6,619.9 293.6,619.9 259.6,535.8  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,515.8 301.6,619.9 297.6,619.9 259.6,525.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,505.8 305.7,619.9 301.6,619.9 259.6,515.8  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,495.8 309.7,619.9 305.7,619.9 259.6,505.8  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,485.8 313.7,619.9 309.7,619.9 259.6,495.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,475.8 317.8,619.9 313.7,619.9 259.6,485.8  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,465.8 321.8,619.9 317.8,619.9 259.6,475.8  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,455.9 325.8,619.9 321.8,619.9 259.6,465.8  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,445.9 329.9,619.9 325.8,619.9 259.6,455.9  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,435.9 333.9,619.9 329.9,619.9 259.6,445.9  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,425.9 337.9,619.9 333.9,619.9 259.6,435.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "259.6,418.3 260.5,417.9 341.9,619.9 337.9,619.9 259.6,425.9  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "260.5,417.9 263.9,416.5 346,619.9 341.9,619.9  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "263.9,416.5 267.4,415.1 350,619.9 346,619.9  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "267.4,415.1 270.9,413.7 354,619.9 350,619.9  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "270.9,413.7 274.3,412.3 358.1,619.9 354,619.9  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "274.3,412.3 277.8,410.9 362.1,619.9 358.1,619.9  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "277.8,410.9 281.3,409.5 366.1,619.9 362.1,619.9  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "281.3,409.5 284.7,408.1 370.2,619.9 366.1,619.9  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "284.7,408.1 288.2,406.7 374.2,619.9 370.2,619.9  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "288.2,406.7 291.7,405.3 378.2,619.9 374.2,619.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "291.7,405.3 295.1,403.9 382.3,619.9 378.2,619.9  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "295.1,403.9 298.6,402.5 386.3,619.9 382.3,619.9  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "298.6,402.5 302.1,401.1 390.3,619.9 386.3,619.9  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "302.1,401.1 305.6,399.7 394.4,619.9 390.3,619.9  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "305.6,399.7 309,398.3 398.4,619.9 394.4,619.9  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "309,398.3 312.5,396.9 402.4,619.9 398.4,619.9  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "312.5,396.9 316,395.5 406.5,619.9 402.4,619.9  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "316,395.5 319.4,394.1 410.5,619.9 406.5,619.9  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.4,394.1 322.9,392.7 414.5,619.9 410.5,619.9  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "322.9,392.7 326.4,391.3 418.6,619.9 414.5,619.9  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "326.4,391.3 329.8,389.9 422.5,619.7 422.2,619.9 418.6,619.9  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 376.1,
    y: 380.2,
    transform: "matrix(0.9274 -0.3742 0.3742 0.9274 -161.1886 178.0411)",
    className: "st1",
    width: 3.7,
    height: 247.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 379.5,
    y: 378.8,
    transform: "matrix(0.9274 -0.3742 0.3742 0.9274 -160.4131 179.2374)",
    className: "st1",
    width: 3.7,
    height: 247.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 377.4,
    transform: "matrix(0.9274 -0.3742 0.3742 0.9274 -159.6375 180.4334)",
    className: "st1",
    width: 3.7,
    height: 247.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 376,
    transform: "matrix(0.9274 -0.3742 0.3742 0.9274 -158.8618 181.6293)",
    className: "st1",
    width: 3.7,
    height: 247.8
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "343.7,384.3 346.1,383.4 347.3,383.4 439.9,612.7 436.4,614.1  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "351.4,383.4 443.4,611.3 439.9,612.7 347.3,383.4  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "355.4,383.4 446.8,609.9 443.4,611.3 351.4,383.4  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "359.4,383.4 450.3,608.5 446.8,609.9 355.4,383.4  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "363.5,383.4 453.8,607.1 450.3,608.5 359.4,383.4  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "367.5,383.4 457.2,605.7 453.8,607.1 363.5,383.4  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "371.5,383.4 460.7,604.3 457.2,605.7 367.5,383.4  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "375.6,383.4 464.2,602.9 460.7,604.3 371.5,383.4  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.6,383.4 467.6,601.5 464.2,602.9 375.6,383.4  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383.6,383.4 471.1,600.1 467.6,601.5 379.6,383.4  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.7,383.4 474.6,598.7 471.1,600.1 383.6,383.4  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.7,383.4 478,597.3 474.6,598.7 387.7,383.4  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.7,383.4 481.5,595.9 478,597.3 391.7,383.4  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.8,383.4 481.7,586.5 481.7,595.9 481.5,595.9 395.7,383.4  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "403.8,383.4 481.7,576.5 481.7,586.5 399.8,383.4  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "407.8,383.4 481.7,566.5 481.7,576.5 403.8,383.4  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "411.9,383.4 481.7,556.5 481.7,566.5 407.8,383.4  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "415.9,383.4 481.7,546.5 481.7,556.5 411.9,383.4  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "419.9,383.4 481.7,536.5 481.7,546.5 415.9,383.4  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "424,383.4 481.7,526.5 481.7,536.5 419.9,383.4  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "428,383.4 481.7,516.5 481.7,526.5 424,383.4  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "432,383.4 481.7,506.5 481.7,516.5 428,383.4  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "436.1,383.4 481.7,496.5 481.7,506.5 432,383.4  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "440.1,383.4 481.7,486.5 481.7,496.5 436.1,383.4  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "442.9,383.4 481.7,479.6 481.7,486.5 440.1,383.4  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.7,383.4 481.7,472.7 481.7,479.6 442.9,383.4  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "448.5,383.4 481.7,465.7 481.7,472.7 445.7,383.4  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.3,383.4 481.7,458.8 481.7,465.7 448.5,383.4  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.1,383.4 481.7,451.8 481.7,458.8 451.3,383.4  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.9,383.4 481.7,444.9 481.7,451.8 454.1,383.4  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "459.7,383.4 481.7,438 481.7,444.9 456.9,383.4  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "462.5,383.4 481.7,431 481.7,438 459.7,383.4  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.3,383.4 481.7,424.1 481.7,431 462.5,383.4  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.1,383.4 481.7,417.1 481.7,424.1 465.3,383.4  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.9,383.4 481.7,410.2 481.7,417.1 468.1,383.4  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.7,383.4 481.7,403.3 481.7,410.2 470.9,383.4  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.5,383.4 481.7,396.3 481.7,403.3 473.7,383.4  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.3,383.4 481.7,389.4 481.7,396.3 476.5,383.4  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481.7,389.4 479.3,383.4 481.7,383.4  "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.6,260.2h-5.2h-5.2c-8.1,0.8-15.7,3.4-22.3,7.3c-2.4,1.4-4.7,3-6.8,4.8c-2.9,2.4-5.6,5.1-7.9,8.1 c-6.8,8.5-11,19.1-11.6,30.7v5.6c0.8,15.6,8.2,29.4,19.5,38.8c9.3,7.7,21.3,12.4,34.4,12.4c1.1,0,2.3,0,3.4-0.1 c0.4,0,0.7-0.1,1.1-0.1c0.7-0.1,1.5-0.1,2.2-0.2c0.4-0.1,0.9-0.1,1.3-0.2c0.7-0.1,1.3-0.2,2-0.3c0.4-0.1,0.9-0.2,1.3-0.3 c0.6-0.1,1.3-0.3,1.9-0.4c0.4-0.1,0.9-0.2,1.3-0.4c0.6-0.2,1.2-0.3,1.8-0.5c0.4-0.1,0.9-0.3,1.3-0.4c0.6-0.2,1.2-0.4,1.8-0.6 c0.4-0.2,0.8-0.3,1.2-0.5c0.6-0.2,1.2-0.5,1.8-0.8c0.4-0.2,0.8-0.3,1.1-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0.1-0.1 c0.8-0.4,1.5-0.8,2.3-1.2l-12.7-15c-0.8,0.3-1.6,0.6-2.4,0.9c-0.4,0.1-0.8,0.3-1.3,0.4c-0.6,0.2-1.3,0.3-1.9,0.5 c-0.4,0.1-0.8,0.2-1.2,0.3c-0.7,0.1-1.5,0.2-2.2,0.3c-0.4,0-0.7,0.1-1.1,0.1c-1.1,0.1-2.2,0.2-3.4,0.2 c-17.2,0-31.5-12.5-34.4-28.9c-0.4-2-0.5-4-0.5-6c0-2.1,0.2-4.1,0.5-6c0.8-4.5,2.4-8.8,4.8-12.5c3.5-5.6,8.6-10.1,14.6-13 c4.5-2.2,9.6-3.4,15-3.4c19.3,0,34.9,15.6,34.9,34.9c0,6.8-2,13.2-5.4,18.6c-0.5,0.8-0.5,1.8,0.1,2.5l9.9,11.7 c0.9,1,2.4,1,3.3-0.1c6.9-9.1,11.1-20.4,11.1-32.7C465.3,285.9,443.9,262.9,416.6,260.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M411.4,370.6c-13.2,0-26-4.6-36.1-13c-12.2-10.1-19.7-25-20.5-40.8l0-5.7c0.6-12,4.8-23.1,12.2-32.4 c2.4-3.1,5.2-5.9,8.3-8.5c2.2-1.8,4.6-3.5,7.1-5c7.2-4.3,15.1-6.9,23.5-7.7l10.7,0c0.1,0,0.2,0,0.3,0 c29.2,2.8,51.2,27.1,51.2,56.4c0,12.6-4,24.4-11.6,34.4c-0.9,1.2-2.3,1.9-3.7,1.9c-1.3-0.1-2.9-0.6-3.8-1.7l-9.9-11.7 c-1.4-1.6-1.5-3.9-0.4-5.7c3.2-5.1,4.9-11,4.9-17.1c0-17.7-14.4-32.1-32.1-32.1c-4.8,0-9.5,1-13.8,3.1 c-5.5,2.6-10.2,6.8-13.4,12c-2.2,3.5-3.7,7.4-4.4,11.5c-0.3,1.8-0.5,3.7-0.5,5.6c0,1.9,0.2,3.7,0.5,5.5 c2.7,15.4,16,26.6,31.6,26.6c1.1,0,2.1-0.1,3.1-0.2l1.3,2.6l-0.4-2.7c0.7-0.1,1.4-0.2,2-0.3l0.8-0.2c1-0.2,1.6-0.4,2.1-0.5 l0.8-0.3c1.2-0.4,1.9-0.6,2.6-0.9c1.1-0.5,2.4-0.2,3.2,0.8l12.7,15c0.5,0.6,0.8,1.5,0.6,2.3c-0.1,0.8-0.6,1.5-1.4,1.9 c-0.7,0.4-1.5,0.8-2.2,1.1l0,0c-0.1,0.1-0.2,0.1-0.3,0.2l-1.6,0.7c-0.6,0.3-1.2,0.5-1.8,0.8l-1.3,0.5c-0.6,0.2-1.3,0.5-1.9,0.7 l-4.7,1.4c-0.6,0.2-1.3,0.3-2,0.5l-1.4,0.3c-0.7,0.1-1.4,0.2-2.1,0.3l-1.3,0.2c-0.8,0.1-1.6,0.2-2.3,0.2l-1.2,0.1 C413.7,370.6,412.6,370.6,411.4,370.6z M406.1,263c-7.3,0.7-14.4,3-20.9,6.9c-2.3,1.4-4.4,2.9-6.4,4.5 c-2.8,2.3-5.3,4.9-7.5,7.6c-6.7,8.4-10.5,18.5-11,29.1l0,5.4c0.7,14.1,7.5,27.5,18.5,36.7c10,8.3,23,12.5,35.8,11.6 c0,0,1-0.1,1-0.1c0.7-0.1,1.4-0.1,2.1-0.2l0.9-0.1c1-0.1,1.6-0.2,2.2-0.4l1.2-0.3c0.7-0.1,1.3-0.3,1.9-0.4l4.2-1.3 c0.6-0.2,1.1-0.4,1.7-0.6l3.5-1.5l-9.2-10.8c-0.2,0.1-0.4,0.1-0.6,0.2L422,350c-0.7,0.2-1.4,0.4-2.1,0.5l-1.4,0.3 c-0.7,0.1-1.5,0.3-2.3,0.4l-1.2,0.2c-19.5,1.9-37.4-11.7-40.7-31c-0.4-2.1-0.6-4.3-0.6-6.5c0-2.2,0.2-4.4,0.6-6.5 c0.8-4.8,2.6-9.3,5.2-13.5c3.8-6.1,9.2-10.9,15.7-14c5.1-2.4,10.5-3.6,16.2-3.6c20.8,0,37.6,16.9,37.6,37.6 c0,7-1.9,13.8-5.6,19.7l9.1,10.7c6.5-8.8,10-19.3,10-30.4c0-26.5-19.8-48.3-46.1-50.9H406.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 411.4,
    cy: 314,
    r: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M411.4,328.8c-8.2,0-14.8-6.6-14.8-14.8c0-8.2,6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8 C426.2,322.2,419.6,328.8,411.4,328.8z M411.4,304.8c-5.1,0-9.3,4.2-9.3,9.3c0,5.1,4.2,9.3,9.3,9.3c5.1,0,9.3-4.2,9.3-9.3 C420.7,308.9,416.5,304.8,411.4,304.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 411.4,
    cy: 314,
    r: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M411.4,328.8c-8.2,0-14.8-6.6-14.8-14.8c0-8.2,6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8 C426.2,322.2,419.6,328.8,411.4,328.8z M411.4,304.8c-5.1,0-9.3,4.2-9.3,9.3c0,5.1,4.2,9.3,9.3,9.3c5.1,0,9.3-4.2,9.3-9.3 C420.7,308.9,416.5,304.8,411.4,304.8z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.ded6f569fd81d10b627f86883564633c.svg";
export { ForwardRef as ReactComponent };